export const UPDATE_VIP_OVERVIEW = 'UPDATE_VIP_OVERVIEW';

export const updateVipOverview = (payload: string[]) => ({
    type: UPDATE_VIP_OVERVIEW,
    payload,
});

export default (state = [] as string[], action: ReturnType<typeof updateVipOverview>) =>
    action.type === UPDATE_VIP_OVERVIEW ? action.payload : state;
